export default __webpack_public_path__ + "static/media/head1.67aadc97.svg";